import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

export const ListingHeader = () => {
  const navigate = useNavigate();
  return (
    <Button
      variant="ghost"
      className="mb-4 pl-0 justify-start"
      onClick={() => navigate(-1)}
    >
      <ArrowLeft className="h-5 w-5 mr-2" />
      Back
    </Button>
  );
};
